'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.menu.listTitle,
      paddingTop = _theme$reactackle$com.paddingTop,
      paddingBottom = _theme$reactackle$com.paddingBottom,
      paddingX = _theme$reactackle$com.paddingX;


  var itemPx = theme.reactackle.components.menu.item.paddingX;

  return (0, _styledComponents.css)(['padding:', '  ', '  ', ';'], (0, _reactackleCore.getValueString)(paddingTop), (0, _reactackleCore.getValueString)(paddingX || itemPx), (0, _reactackleCore.getValueString)(paddingBottom || paddingTop));
};

var typography = function typography(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com2 = theme.reactackle.components.menu.listTitle,
      fontSize = _theme$reactackle$com2.fontSize,
      fontWeight = _theme$reactackle$com2.fontWeight,
      fontColor = _theme$reactackle$com2.fontColor,
      lineHeight = _theme$reactackle$com2.lineHeight,
      textTransform = _theme$reactackle$com2.textTransform;


  return (0, _styledComponents.css)(['font-size:', ';font-weight:', ';line-height:', ';text-transform:', ';color:', ';'], (0, _reactackleCore.getValueString)(fontSize), fontWeight, lineHeight, textTransform, fontColor);
};

var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TitleStyled'
})(['margin:0;list-style-type:none;display:block;', ' ', ''], typography, size);

TitleStyled.displayName = 'TitleStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/MenuList/styles/TitleStyled.js
// module id = 753
// module chunks = 0